import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { AuthContext, AuthProvider } from "./context/AuthContext";
import Login from "./components/Login";
import Signup from "./components/Signup";
import Dashboard from "./components/Dashboard";
import Home from "./components/Home";
import Error from "./components/Error";
import { AnimatePresence } from "framer-motion";
import ForgotPassword from "./components/ForgotPassword";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import StockEntryForm from "./components/Dashboards/Admin/StockEntryForm";

import BillingForm from "./components/Dashboards/Admin/NotInUse/BillingForm";
import PetrolPumpProfile from "./components/Dashboards/Admin/NotInUse/PetrolPumpProfile";
import ProfileForm from "./components/Dashboards/Admin/ProfileForm";
import DashboardOverview from "./components/Dashboards/Admin/Dashboard";
import DrillingDataEntryForm from "./components/Dashboards/Admin/Forms/DrillingDataEntryForm";
import DrillingDataTable from "./components/Dashboards/Admin/Tables/DrillingDataTable";
import FormCreateVehicle from "./components/Dashboards/Admin/NotInUse/FormCreateVehicle";
import VehiclesTable from "./components/Dashboards/Admin/Tables/VehicalTable";
import AgentEntryForm from "./components/Dashboards/Admin/NotInUse/AgentEntryForm";
import AgentComponent from "./components/Dashboards/Admin/AgentComponent";
import CreateBill from "./components/Dashboards/Admin/Forms/CreateBill";
import ProjectTabs from "./components/Dashboards/ProjectTabs";
import AgentDetailsComponent from "./components/Dashboards/Admin/AgentDetailsComponent";
import CreateSupplierForm from "./components/Dashboards/Admin/Forms/CreateSupplierForm";
import CreateProductForm from "./components/Dashboards/Admin/Forms/CreateProductForm";
import StockManagement from "./components/Dashboards/Admin/StockManagement";



const App = () => {
  const { loginUser, logout } = useContext(AuthContext); // This now works because AuthProvider wraps it

  return (
    <Router>
      <AnimatePresence>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/signup" element={<Signup />} />
          <Route element={<Dashboard />}>
            {loginUser?.role === "admin" && (
              <>
                <Route path="/dashboard" element={<DashboardOverview />} />
                <Route path="/dashboard/drilling-form" element={<DrillingDataEntryForm />} />
                <Route path="/dashboard/add-bill" element={<CreateBill />} />

                <Route path="/dashboard/vehicle-form" element={<FormCreateVehicle />} />
                <Route path="/dashboard/agent-form" element={<AgentEntryForm />} />
                <Route path="/dashboard/supplier-form" element={<CreateSupplierForm />} />
                <Route path="/dashboard/product-form" element={<CreateProductForm />} />
                <Route path="/dashboard/agent" element={<AgentComponent />} />
                <Route path="/dashboard/stock" element={<StockManagement />} />
                <Route path="/dashboard/agent/:agentId" element={<AgentDetailsComponent />} />
                <Route path="/dashboard/data-tables" element={<ProjectTabs />} />
                <Route path="/dashboard/stock-management" element={< StockEntryForm />} />
                <Route path="/dashboard/profile" element={<ProfileForm />} />0
              </>
            )}
            <Route path="*" element={<Error />} />
          </Route>
        </Routes>
      </AnimatePresence>
    </Router>
  );
};

const RootApp = () => (
  <AuthProvider>
    <App />
    <ToastContainer />
  </AuthProvider>
);

export default RootApp;
